var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSlice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pie_chart_FILL1_wght400_GRAD0_opsz24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.25 14.25V3.125C19.2292 3.4375 21.7448 4.625 23.7969 6.6875C25.849 8.75 27.0417 11.2708 27.375 14.25H16.25ZM13.7812 27.8438C10.6146 27.5313 7.96354 26.1979 5.82812 23.8438C3.69271 21.4896 2.625 18.7083 2.625 15.5C2.625 12.2708 3.69271 9.47917 5.82812 7.125C7.96354 4.77083 10.6146 3.4375 13.7812 3.125V27.8438ZM16.25 27.8438V16.7188H27.375C27.0833 19.6979 25.901 22.224 23.8281 24.2969C21.7552 26.3698 19.2292 27.5521 16.25 27.8438Z",
    fill: "#0BA9E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlice);
export default __webpack_public_path__ + "static/media/icon-slice.1013b32e59a6b4cef6898e5477fdcf22.svg";
export { ForwardRef as ReactComponent };